import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { ClipboardCheck, User, Wine } from 'lucide-react';

const BARS = [
    { id: 'lobby', name: 'Lobby Bar' },
    { id: 'servis', name: 'Servis Bar' },
    { id: 'vitamin', name: 'Vitamin Bar' },
    { id: 'havuz', name: 'Havuz Bar' },
    { id: 'plaj', name: 'Plaj Bar' },
    { id: 'amfi', name: 'Amfi Bar' },
    { id: 'teras', name: 'Teras Bar' },
    { id: 'alacarte', name: 'Alacarte Bar' },
    { id: 'minibar', name: 'Minibar' },
];

export default function GarsonEntry() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [garsonName, setGarsonName] = useState('');
    const [selectedBar, setSelectedBar] = useState('');

    const allowedBars = user?.allowed_bars || [];
    // Garson tum barlari gorebilir (allowed_bars filtresi kaldirildi)
    const availableBars = BARS;

    const handleStart = () => {
        if (garsonName.trim() && selectedBar) {
            // Store garson info in sessionStorage
            sessionStorage.setItem('garson_name', garsonName.trim());
            sessionStorage.setItem('garson_bar', selectedBar);
            navigate(`/bar/${selectedBar}`);
        }
    };

    return (
        <div className="min-h-[70vh] flex items-center justify-center" data-testid="garson-entry-page">
            <Card className="w-full max-w-md shadow-lg border-t-4 border-t-blue-500">
                <CardHeader className="text-center pb-2">
                    <div className="w-20 h-20 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-4">
                        <ClipboardCheck className="w-10 h-10 text-blue-600" />
                    </div>
                    <CardTitle className="text-2xl">Bar Stok Sayimi</CardTitle>
                    <p className="text-slate-500 text-sm mt-2">Bilgilerinizi girip sayima baslayin</p>
                </CardHeader>
                <CardContent className="space-y-5 pt-4">
                    {/* Name Input */}
                    <div>
                        <label className="text-sm font-semibold text-slate-700 mb-2 flex items-center gap-2">
                            <User className="w-4 h-4" />
                            Ad Soyad
                        </label>
                        <Input
                            value={garsonName}
                            onChange={(e) => setGarsonName(e.target.value)}
                            placeholder="Adinizi ve soyadinizi girin..."
                            className="h-12 text-base"
                            autoFocus
                            data-testid="garson-name-input"
                        />
                    </div>

                    {/* Bar Selection */}
                    <div>
                        <label className="text-sm font-semibold text-slate-700 mb-2 flex items-center gap-2">
                            <Wine className="w-4 h-4" />
                            Sayim Yapilacak Bar
                        </label>
                        <Select value={selectedBar} onValueChange={setSelectedBar}>
                            <SelectTrigger className="h-12 text-base" data-testid="garson-bar-select">
                                <SelectValue placeholder="Bar secin..." />
                            </SelectTrigger>
                            <SelectContent>
                                {availableBars.map(bar => (
                                    <SelectItem key={bar.id} value={bar.id}>
                                        {bar.name}
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </div>

                    {/* Start Button */}
                    <Button
                        onClick={handleStart}
                        disabled={!garsonName.trim() || !selectedBar}
                        className="w-full h-12 text-base bg-blue-600 hover:bg-blue-700 font-semibold"
                        data-testid="garson-start-btn"
                    >
                        <ClipboardCheck className="w-5 h-5 mr-2" />
                        Sayima Basla
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
}
